import DashboardPage from "./pages/Dashboard";

const App = () => {
  return (
    <DashboardPage />
  )
}

export default App;